import React from "react";

import Typography from "../Typography/Text";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./Card.module.css";

interface HeaderProps {
  header: React.ReactElement | string;
  headerIcon?: React.ReactElement | undefined;
}

const DefaultCardHeader: React.FC<HeaderProps> = ({ header, headerIcon }) => (
  <div className={styles.header}>
    <Typography variant="title1" className={styles.headerText}>
      {header}
    </Typography>
    {headerIcon && <div className={styles.headerIcon}>{headerIcon}</div>}
  </div>
);

export interface CardProps extends HeaderProps {
  className?: string;
  children?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  className,
  header,
  children,
  headerIcon,
}) => {
  const headerIsString = typeof header === "string";

  return (
    <div className={toClassName(styles.container, className)}>
      {headerIsString ? (
        <DefaultCardHeader header={header} headerIcon={headerIcon} />
      ) : (
        header
      )}
      {children}
    </div>
  );
};

export default Card;
